<template>
  <div class="useracceptTOS" id="useracceptTOS">
    <div class="input-container">
      <div class="input-header">
        {{ $t('create_betgame.agree_terms_of_use_2') }}
      </div>
      <div class="register-checkbox">
        <div class="register-checkbox__item">
          <input v-model="agreedTOS" type="checkbox" id="agreedTOS" name="agreedTOS" @change="agreedTOSChanged($event)" />
          <label v-if="userlang === 'de'" for="agreedTOS">{{ $t('create_betgame.agree_terms_of_use_1') }} <a target="_blank" href="/termsofuse">{{ $t('create_betgame.agree_terms_of_use_2') }}</a> {{ $t('create_betgame.agree_terms_of_use_3') }} <a target="_blank" href="/privacy">{{ $t('register.data_protection') }}</a> {{ $t('create_betgame.agree_terms_of_use_4') }}.</label>
          <label v-else for="agreedTOS">{{ $t('create_betgame.agree_terms_of_use_5') }} <a target="_blank" href="/termsofuse">{{ $t('create_betgame.agree_terms_of_use_6') }}</a> {{ $t('create_betgame.agree_terms_of_use_7') }} <a target="_blank" href="/privacy">{{ $t('register.data_protection') }}</a>.</label>
          <div v-if="!this.agreedTOS" class="register-checkbox__item__errortext">{{ $t('create_betgame.agree_terms_of_use_error') }}</div>
        </div>
        <div class="register-checkbox__item">
          <input v-model="isUnder18" type="checkbox" id="isUnder18" name="isUnder18" @change="isUnder18Changed($event)" />
          <label for="isUnder18">{{ $t('create_betgame.i_am_under_18') }} ({{ $t('create_betgame.optional') }})</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'

export default {
  name: 'UserAcceptTOS',
  components: {},
  props: {
  },
  data () {
    return {
      agreedTOS: false,
      isUnder18: false
    }
  },
  beforeCreate () {
    Vue.$log.debug('UserAcceptTOS.beforeCreate ' + this.betmode)
  },
  created () {
    Vue.$log.debug('UserAcceptTOS.created ' + this.betmode)
  },
  mounted () {
    Vue.$log.debug('UserAcceptTOS.mounted ' + this.betmode)
  },
  computed: {
    userlang () {
      return this.$store.state.language
    }
  },
  methods: {
    isUnder18Changed() {
      this.$store.dispatch('setCreateBetgame', {
        key: 'isUnder18',
        value: this.isUnder18
      })
      .then(() => {
        Vue.$log.debug('UserAcceptTOS.isUnder18Changed ok ' + this.isUnder18)
      }).catch(function (error) {
        Vue.$log.debug('UserAcceptTOS.isUnder18Changed error ' + error)
      })
    },
    agreedTOSChanged(event) {
      this.$store.dispatch('setCreateBetgame', {
        key: 'agreedTOS',
        value: this.agreedTOS
      }).then(() => {
        Vue.$log.debug('UserAcceptTOS.agreedTOSChanged ok ' + this.betmode)
      }).catch(function (error) {
        Vue.$log.debug('UserAcceptTOS.agreedTOSChanged error ' + error)
      })
      this.$emit('agreedTOSChanged', this.agreedTOS)
      /*
      if(this.agreedTOS === true) {
        const item = document.querySelector('.register-checkbox__item')
        item.classList.remove('haserror')
      } else {
        const item = document.querySelector('.register-checkbox__item')
        item.classList.add('haserror')
      }
       */
    }
  }
}
</script>

<style lang="scss" scoped>

.useracceptTOS {
  max-width: 400px;
  margin: 16px auto 16px;
}

.register-checkbox {
  display: flex;
  flex-direction: column;
  margin-top: 0px;
  margin-bottom: 16px;

  &__item {

    input {
      display: none;
    }

    label {
      box-sizing: border-box;
      padding: 10px 0 10px 32px;
      display: inline-block;
      position: relative;
      width: 100%;
      font-size: 14px;
      color: rgba(var(--color-text-rgb), .64);
      cursor: pointer;

      a {
        color: rgba(var(--color-text-rgb), .64);
        text-decoration: underline;
        &:hover {
          color: var(--color-text);
          transition: all .2s ease-in-out;
        }
      }

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        width: 20px;
        height: 20px;
        background: url('../../assets/icons/ic_20_checkbox.svg');
      }
    }

    &.haserror {
      label {
        &:before {
          background: url('../../assets/icons/ic_20_checkbox_error.svg');
        }
      }
    }

    &__errortext {
      display: none;
      font-size: 14px;
      color: var(--color-negative);
      padding-left: 32px;
      margin: -4px 0 16px;

      .haserror & {
        display: flex;
      }
    }

    input[type="checkbox"]:checked+label:before {
      background: url('../../assets/icons/ic_20_checkbox_active.svg');
    }

    &:last-child {
      label {
        border-bottom: 0;
      }
    }
  }

}

</style>
